import { CurrencyInfo } from '@percent/admin-dashboard/api/actions/currencies/currencies.types'

export const getCurrencyMinorUnits = (currencyCode: string, currencies: CurrencyInfo[]) => {
  const minorUnits = currencies?.find(currency => currency.code === currencyCode)?.minorUnits

  return minorUnits !== undefined ? minorUnits : 2
}
